/**
 * Copyright (C), 2012-2019, Sichuan Xiaoka Technology Co., Ltd.
 * */
import Vue from 'vue'

const supplementZero = (num) => { // 自动补充 0
  num = Number(num)
  return (num < 10 ? '0' + num : num)
}

Vue.filter('time', (val, type = 'timeStamp', format = 'YYYY-MM-DD HH:MM:SS') => {
  if (type === 'timeStamp') {
    let Dates = null
    format = format || 'YYYY-MM-DD HH:MM:SS'
    if (!val) {
      return '无'
    }
    if (val instanceof Object) {
      Dates = new Date(val)
    } else if (Number(val)) {
      val = (val += '').length === 13 ? Number(val) : Number(val) * 1000
      Dates = new Date(val)
    } else {
      return val
    }
    let year = Dates.getFullYear() // 年
    let month = supplementZero(Dates.getMonth() + 1) // 月
    let date = supplementZero(Dates.getDate()) // 日
    let hour = supplementZero(Dates.getHours()) // 时
    let minute = supplementZero(Dates.getMinutes()) // 分
    let second = supplementZero(Dates.getSeconds()) // 秒
    format = format.toUpperCase()
    format = format.replace(/YYYY/, year)
    format = format.replace(/MM/, month)
    format = format.replace(/DD/, date)
    format = format.replace(/HH/, hour)
    format = format.replace(/MM/, minute)
    format = format.replace(/SS/, second)
    return format
  }
})

Vue.filter('orderStatusFilter', (status) => { // 过滤订单装填
  let name = Number(status)
  switch (status) {
    case 1:
      name = '派单中'
      break
    case 5:
      name = '已派单'
      break
    case 10:
      name = '已接单'
      break
    case 15:
      name = '前往预约地'
      break
    case 20:
      name = '到达预约地'
      break
    case 25:
      name = '前往目的地'
      break
    case 28:
      name = '中途等待'
      break
    case 30:
      name = '未支付'
      break
    case 35:
      name = '待评价'
      break
    case 40:
      name = '已评价'
      break
    case 45:
      name = '已销单'
      break
  }
  return name
})




// WEBPACK FOOTER //
// ./src/filter/index.js